import { render, staticRenderFns } from "./AQuickActionButtons.vue?vue&type=template&id=50606cfa&"
import script from "./AQuickActionButtons.vue?vue&type=script&lang=ts&"
export * from "./AQuickActionButtons.vue?vue&type=script&lang=ts&"
import style0 from "./AQuickActionButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverflowBtn } from 'vuetify/lib/components/VOverflowBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VOverflowBtn,VProgressCircular,VSpacer})
